import { marketResearchRoutes } from "app/pages/industry-analysis/routes";
import type { RouterStateConfig } from "single-spa/react-app/router/IRouterState";

export const marketResearchConfig: RouterStateConfig = marketResearchRoutes;
